import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {FILE_FORMATS} from '../../../constants/Lookup';

const initialData = {
  addEnableFileFormatData: {},
  dropDownData: {},
  addEnableFileFormatStatus: null,
  addEnableFileFormatSystemNotesStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  isSystemNotesLoading: false,
};

const slice = createSlice({
  name: 'addEnableFileFormat',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNotesLoading = true;
      state.errorMsg = null;
    },
    fetchAddEnableFileFormatData: (state, action) => {
      state.addEnableFileFormatData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAddEnableFileFormatData: (state, action) => {
      state.addEnableFileFormatStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    postEnableFileImportData: (state, action) => {
      state.addEnableFileFormatStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postAddEnableFileFormatDataSystemNotes: (state, action) => {
      state.addEnableFileFormatSystemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
      state.isSystemNotesLoading = false;
    },
    resetAddEnableFileFormatStatus: (state) => {
      state.addEnableFileFormatStatus = null;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
      state.isSystemNotesLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.statusText ? action.payload.statusText : '';
      state.isLoading = false;
      state.isSystemNotesLoading = false;
    },
    fetchAddEnableError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
      state.isSystemNotesLoading = false;
    },
    resetNotesMsg: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.isSystemNotesLoading = false;
      state.addEnableFileFormatSystemNotesStatus = null;
    },
    resetMsg: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addEnableFileFormatStatus = null;
      state.addEnableFileFormatData = {};
      state.isSystemNotesLoading = false;
      state.addEnableFileFormatSystemNotesStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  postAddEnableFileFormatData,
  fetchAddEnableError,
  fetchAddEnableFileFormatData,
  fetchStart,
  fetchError,
  resetMsg,
  fetchSuccess,
  resetAddEnableFileFormatStatus,
  fetchDropDownData,
  postAddEnableFileFormatDataSystemNotes,
  postEnableFileImportData,
  fetchNoteStart,
  resetNotesMsg,
} = slice.actions;

export const postAddEnableFileFormat = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enableintegration/save/integration/`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchAddEnableError(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(postAddEnableFileFormatData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error && error.message ? error.message : error));
      });
  };
};

export const getLookupData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [FILE_FORMATS],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchEnableFileFormatData = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`enableintegration/find/integration/${id}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchAddEnableFileFormatData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const saveEnableFileFormatSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    Promise.all([httpPost('enableintegration/save/enbalefileformat/notes', details)])
      .then((data) => {
        const data1 = data[0];
        if (data1?.status === 200 && data1?.status === 400) {
          dispatch(fetchError(data));
        } else if (data1 && data1.status && data1.status === 200) {
          dispatch(postAddEnableFileFormatDataSystemNotes(data1));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postEnableFileFormatImportData = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enablefileformat/import`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postEnableFileImportData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetAddEnableFileFormat = () => {
  return (dispatch) => {
    dispatch(resetAddEnableFileFormatStatus());
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const ResetNotesToast = () => {
  return (dispatch) => {
    dispatch(resetNotesMsg());
  };
};
